import apolloClient from './../apolloClient.js'

const state = {
  techcenter: {}
}

const mutations = {
  SET_TECHCENTER (state, techcenter) {
    state.techcenter = Object.assign({}, techcenter)
  },
  CLEAR_TECHCENTER_DATA (state) {
    state.techcenter = {}
  }
}

import getTechcenterByIdQuery from './../gql/queries/getTechcenterById.graphql'
import blockTechcenterMutation from './../gql/mutations/BlockTechcenter.graphql'
const actions = {
  getTechcenterById: ({commit}, {id, imgWidth, imgHeight}) => {
    return new Promise((resolve, reject) => {
      apolloClient.query({
        query: getTechcenterByIdQuery,
        variables: {
          id: [id],
          imgWidth,
          imgHeight
        },
        fetchPolicy: 'network-only'
      }).then((result) => {
        if (result.data.techcenters[0]) {
          commit('SET_TECHCENTER', result.data.techcenters[0])
        }
        resolve(result)
      }).catch((error) => {
        console.warn(error)
        reject()
      })
    })
  },
  blockTechcenter: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: blockTechcenterMutation,
        variables: {
          id: params.id,
          enabled: params.enabled
        }
      }).then((result) => {
        commit('SET_TECHCENTER', result.data.blockTechcenter)
        resolve(result)
      }).catch((error) => {
        console.warn(error)
        reject(error)
      })
    })
  }
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/techcenterStore.js